export type OdinPhoto = {
  slug: string;
  alt: string;
  caption: string;
  note: string;
};

export const odinGallery: OdinPhoto[] = [
  {
    slug: "odin-01",
    alt: "Odin lying on a sofa with his head resting on the edge",
    caption: "Chief relaxation officer",
    note: "Keeping the sofa warm between travel, meetings, and everything else.",
  },
  {
    slug: "odin-02",
    alt: "Odin carrying a blue frisbee outdoors",
    caption: "Frisbee department",
    note: "Fast, focused, and extremely serious about outdoor product testing.",
  },
  {
    slug: "odin-03",
    alt: "Odin riding the London Underground and looking to the side",
    caption: "The London commuter",
    note: "Perfectly at home on the Tube—and probably better behaved than most passengers.",
  },
  {
    slug: "odin-04",
    alt: "Odin running with a long stick in a grassy park",
    caption: "Branch manager",
    note: "Ambitious scope, strong ownership, questionable approach to resource sizing.",
  },
  {
    slug: "odin-05",
    alt: "Odin standing in a bright outdoor space with a blue bandana",
    caption: "Park patrol",
    note: "Blue bandana on, standards high, ready for the next London adventure.",
  },
];

export const odinImageWidths = [480, 960, 1200] as const;

export function odinImagePath(slug: string, width: number) {
  return `/odin/${slug}-${width}.jpg`;
}
